var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.476,
    height: 133.975,
    viewBox: "0 0 112.476 133.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(-672.584 -1674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(256.469 38.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M4.831,32.424A1.081,1.081,0,0,1,3.75,31.343V14.831A1.081,1.081,0,0,1,4.831,13.75H8.959a5.209,5.209,0,0,1,0,10.418H5.912v7.175A1.081,1.081,0,0,1,4.831,32.424ZM5.912,22.006H8.959a3.047,3.047,0,0,0,0-6.094H5.912Z",
    transform: "translate(440.709 1633.084)",
    fill: "#807ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M22.335,18.912h-5.5a1.081,1.081,0,1,1,0-2.162h5.5a1.081,1.081,0,0,1,0,2.162Z",
    transform: "translate(461.732 1638.34)",
    fill: "#807ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M16.831,32.424a1.081,1.081,0,0,1-1.081-1.081V14.831a1.081,1.081,0,0,1,1.081-1.081h8.256a1.081,1.081,0,1,1,0,2.162H17.912V31.343A1.081,1.081,0,0,1,16.831,32.424Z",
    transform: "translate(461.732 1633.084)",
    fill: "#807ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M10.831,13.75h2.752a6.592,6.592,0,0,1,6.585,6.585v5.5a6.592,6.592,0,0,1-6.585,6.585H10.831A1.081,1.081,0,0,1,9.75,31.343V14.831A1.081,1.081,0,0,1,10.831,13.75Zm2.752,16.512a4.428,4.428,0,0,0,4.423-4.423v-5.5a4.428,4.428,0,0,0-4.423-4.423H11.912v14.35Z",
    transform: "translate(451.22 1633.084)",
    fill: "#807ce0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M121.378,23.322a9.792,9.792,0,0,0-6.372-6.372,10,10,0,0,0-9.558-6.85H25.636A9.994,9.994,0,0,0,15.6,20.136V121.295a10.155,10.155,0,0,0,6.85,9.558,9.792,9.792,0,0,0,6.372,6.372,9.953,9.953,0,0,0,9.4,6.85h70.094a19.75,19.75,0,0,0,19.754-19.754v-91.6A9.422,9.422,0,0,0,121.378,23.322ZM18.945,121.135V19.977a6.9,6.9,0,0,1,6.85-6.85h79.812a6.9,6.9,0,0,1,6.85,6.85V121.135a6.9,6.9,0,0,1-6.85,6.85H25.636A6.979,6.979,0,0,1,18.945,121.135Zm7.328,9.877h79.175a9.994,9.994,0,0,0,10.036-10.036V20.614a6.9,6.9,0,0,1,3.186,5.735v96.22A11.694,11.694,0,0,1,107.041,134.2H32.008A7.119,7.119,0,0,1,26.273,131.012ZM125.042,124a16.555,16.555,0,0,1-16.568,16.568H38.381a6.9,6.9,0,0,1-5.735-3.186h74.4a14.89,14.89,0,0,0,14.815-14.815V26.986a6.9,6.9,0,0,1,3.186,5.735Z",
    transform: "translate(656.984 1663.9)",
    fill: "#807ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M20.435,65.77a3.713,3.713,0,0,1-2.429-.85,2.609,2.609,0,0,1-1.093-2.794C17.52,58.6,24.686,54.11,31,51.073c1.093-1.943,2.065-4.008,3.158-6.316A93.759,93.759,0,0,0,37.8,35.283c-2.308-6.316-3.037-13.361-1.458-16.519A3.123,3.123,0,0,1,39.262,16.7a2.855,2.855,0,0,1,2.551,1.458c1.822,2.915.729,10.081-1.458,17.126A25.377,25.377,0,0,0,44,41.721a29.631,29.631,0,0,0,4.494,4.251c7.045-1.093,13.968-1.093,16.4,1.336a3.123,3.123,0,0,1,.729,3.4,4,4,0,0,1-3.4,2.794c-3.644.729-9.474-1.458-14.454-4.98a78.147,78.147,0,0,0-9.6,2.308h0q-2.551.911-5.466,2.186c-3.037,5.587-7.166,11.66-11.174,12.632C21.164,65.649,20.8,65.77,20.435,65.77Zm8.259-10.81c-4.98,2.672-9.11,5.83-9.474,7.531,0,.121,0,.243.243.486a1.551,1.551,0,0,0,1.458.243C22.986,62.734,25.658,59.7,28.695,54.96Zm22.713-7.045c3.887,2.308,8.016,3.522,10.2,3.037a1.936,1.936,0,0,0,1.579-1.215c.121-.486,0-.729-.121-.85C61.732,47.672,57.238,47.308,51.408,47.915ZM39.019,38.684a65.512,65.512,0,0,1-2.794,7.045c-.486.972-1.093,2.308-1.822,3.765A22.624,22.624,0,0,1,37.318,48.4h0a60.516,60.516,0,0,1,7.773-1.943,20.935,20.935,0,0,1-3.279-3.279A31.6,31.6,0,0,1,39.019,38.684Zm0-19.555c-.121,0-.364,0-.729.729-.972,1.943-.729,6.437.486,11.174,1.458-5.709,1.7-10.081.729-11.539C39.383,19.251,39.262,19.129,39.019,19.129Z",
    transform: "translate(681.31 1715.041)",
    fill: "#807ce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_124",
    "data-name": "Line 124",
    d: "M95,1.25H0v-2.5H95Z",
    transform: "translate(674.5 1715.5)",
    fill: "#807ce0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.abd74842d6ee65e6b4008bc267631944.svg";
export { ForwardRef as ReactComponent };